import {type DefaultError, useMutation} from "@tanstack/react-query";
import type {UrlMutationVariables} from "../../../query/queryClient";
import {queryHttp} from "../../../query/queryHttp";
import {environment} from "../../../env";
import {CHAT_CONFIG} from "../services/ChatConfiguration";

export type RenameSessionVariables = {
    sessionId: string;
    appName: string;
    displayName: string;
};

export type RenameSessionResponse = {
    message: string;
};

function renameSessionMutationVariables({
                                            sessionId,
                                            appName,
                                            displayName,
                                        }: RenameSessionVariables): UrlMutationVariables {
    if (!CHAT_CONFIG.API_URL && !environment.isTestChat) {
        throw new Error("Chat API URL is not configured");
    }

    return {
        url: `${CHAT_CONFIG.API_URL}/sessions/${encodeURIComponent(sessionId)}/rename`,
        method: "PATCH",
        params: {app_name: appName},
        data: {display_name: displayName},
    };
}

/**
 * `PATCH /api/v1/sessions/{session_id}/rename?app_name=…`
 * Response body: `{ message: string }`.
 */
export function useRenameSessionMutation() {
    return useMutation<RenameSessionResponse, DefaultError, RenameSessionVariables>({
        mutationFn: async (variables) => {
            if (environment.isTestChat) {
                return {message: "Test mode: rename session skipped"};
            }
            const {url, method = "PATCH", ...config} = renameSessionMutationVariables(variables);
            const {data} = await queryHttp.request<RenameSessionResponse>({url, method, ...config});
            return data;
        },
    });
}
